import CONST from './Constant';

const INITIAL_STATE = {
    // Core Image Data (Multiple files support)
    files: [],
    selectedImageId: null, // ID of the currently selected/focused image

    // Current Operation
    activeAction: 'effects',
    activeSubAction: null,

    // Operation Settings
    settings: {
        rotate: { angle: 0 },
        flip: { horizontal: false, vertical: false },
        crop: { x: 0, y: 0, width: 0, height: 0 },
        compress: { quality: 80, maxWidth: null, maxHeight: null },
        format: { targetFormat: 'webp' },
        filter: { type: 'none', intensity: 100 },
        webp: { quality: 80, lossless: false },
        colorBlindness: { type: 'protanopia' },
    },

    // Results (Cached)
    results: {
        base64: null,
        metadata: null,
        colors: null,
    },

    // UI State
    isProcessing: false,
    processingProgress: 0,
    error: null,
};

const imageStudioReducer = (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case CONST.UPDATE_IMAGE_STUDIO_STATE:
            return {
                ...state,
                ...action.payload,
            };

        case CONST.SET_ORIGINAL_IMAGE:
            // For single file (backward compatibility)
            return {
                ...state,
                files: [{
                    id: Date.now() + Math.random(),
                    file: action.payload.file,
                    preview: action.payload.preview,
                    originalSize: action.payload.file.size,
                    status: 'pending',
                    processedFile: null,
                    processedPreview: null,
                    actionHistory: [], // Track all operations applied to this image
                    error: null,
                }],
                error: null,
            };

        case CONST.SET_PROCESSED_IMAGE:
            // Update processed image for first file (backward compatibility)
            if (state.files.length > 0) {
                return {
                    ...state,
                    files: state.files.map((f, idx) =>
                        idx === 0
                            ? { ...f, processedFile: action.payload.blob, processedPreview: action.payload.preview }
                            : f
                    ),
                    error: null,
                };
            }
            return state;

        case CONST.SET_ACTIVE_TAB:
        case CONST.SET_ACTIVE_ACTION:
            return {
                ...state,
                activeAction: action.payload,
                activeSubAction: null,
            };

        case CONST.SET_ACTIVE_OPERATION:
        case CONST.SET_ACTIVE_SUB_ACTION:
            return {
                ...state,
                activeSubAction: action.payload,
            };

        case CONST.UPDATE_IMAGE_STUDIO_FILES:
            // Ensure actionHistory is preserved for all files
            const updatedFiles = action.payload.map((newFile) => {
                const existingFile = state.files.find(f => f.id === newFile.id);
                // If file exists in state and newFile doesn't have actionHistory property, preserve from existing
                if (existingFile && newFile.actionHistory === undefined) {
                    return {
                        ...newFile,
                        actionHistory: existingFile.actionHistory || [],
                    };
                }
                // Ensure actionHistory exists (default to empty array if missing)
                return {
                    ...newFile,
                    actionHistory: newFile.actionHistory !== undefined ? newFile.actionHistory : [],
                };
            });

            console.log('🟢 [UPDATE_IMAGE_STUDIO_FILES] Files updated:', {
                filesCount: updatedFiles.length,
                filesWithHistory: updatedFiles.filter(f => f.actionHistory && f.actionHistory.length > 0).length,
                sampleFile: updatedFiles[0] ? {
                    id: updatedFiles[0].id,
                    hasActionHistory: !!updatedFiles[0].actionHistory,
                    actionHistoryLength: updatedFiles[0].actionHistory?.length || 0,
                } : null,
            });

            return {
                ...state,
                files: updatedFiles,
                // If selected image was removed, clear selection
                selectedImageId: updatedFiles.find(f => f.id === state.selectedImageId)
                    ? state.selectedImageId
                    : null,
                error: null,
            };

        case CONST.SET_SELECTED_IMAGE_ID:
            return {
                ...state,
                selectedImageId: action.payload,
            };

        case CONST.UPDATE_SETTINGS:
            const { operation, settings: newSettings } = action.payload;
            const oldSettings = state.settings[operation];
            const updatedSettings = {
                ...oldSettings,
                ...newSettings,
            };

            console.log('🟠 [UPDATE_SETTINGS] Redux action dispatched:', {
                operation,
                oldSettings,
                newSettings,
                updatedSettings,
                fullPayload: action.payload,
            });

            return {
                ...state,
                settings: {
                    ...state.settings,
                    [operation]: updatedSettings,
                },
            };

        case CONST.SET_RESULTS:
            return {
                ...state,
                results: {
                    ...state.results,
                    [action.payload.operation]: action.payload.results,
                },
            };

        case CONST.RESET_IMAGE_STUDIO:
            return INITIAL_STATE;

        default:
            return state;
    }
};

export default imageStudioReducer;

